import { render, staticRenderFns } from "./Producto.vue?vue&type=template&id=2a8fb410&scoped=true&"
import script from "./Producto.vue?vue&type=script&lang=js&"
export * from "./Producto.vue?vue&type=script&lang=js&"
import style0 from "./Producto.vue?vue&type=style&index=0&id=2a8fb410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8fb410",
  null
  
)

export default component.exports